<div id="appointment-component" #appointmentsSection class="cbw-appointment-wrapper" role="main" aria-label="Main section">
  @if (hasQualificationQuestions && !hasQualificationQuestionsAnswered) {
    <!-- Fullscreen overlay qualification questions  -->
    <app-qualification-question
      [(appointmentState)]="appointmentState"
      [qualificationQuestions]="qualificationQuestions"
      [(qualificationQuestionsValues)]="qualificationQuestionsValues"
      [(userState)]="userState"
      [globals]="globals"
      [partner]="partner"
      [lang]="lang"
      [isFrame]="isFrame"
      [widgetTemplates]="widgetTemplates"
      [qualificationQuestionLSNameKey]="QUALIFICATIONQUESTION_LS_NAME"
      [selectedJsonCustomFields]="selectedJsonCustomFields"
      [supportedWidgetLanguages]="partner?.supported_widget_languages"
      [langSwitcher]="langSwitcher"
      (submitted)="submitQualificationQuestions($event)"
      role="form"
      aria-label="Qualification questions"
    />
  }

  <div [ngClass]="{ 'd-none': hasQualificationQuestions && !hasQualificationQuestionsAnswered }">
    <!-- Fullscreen overlay for saferpay payment gateway to when payment is ongoing  -->
    @if (showFullscreenOverlay) {
      <div class="overlay text-center" role="dialog" aria-modal="true" aria-labelledby="payment-overlay-title" aria-describedby="payment-overlay-description">
        <div class="content">
          <p
            id="payment-overlay-description"
            class="font-weight-light"
            [innerHtml]="('summary_page_translations.saferpay_payment_overlay' | translate) | trustHtml"
          ></p>

          <button
            #button
            class="btn btn-lg btn-warning mt-2"
            (click)="closeSaferpayOverlay()"
            aria-label="Close payment overlay"
          >
            {{ 'common.close' | translate }}
          </button>
        </div>
      </div>
    }

    @if (showStripeRedirectionLoader) {
      <app-loader aria-label="Stripe redirection loader"/>
    }

    @if (booked) {
      <div role="region" aria-labelledby="booking-success-title">
        <app-finalpage
          [lang]="lang"
          [bookingErrorMessage]="bookingErrorMessage"
          [errTitle]="'appointments.finalpage.errorTitle' | translate"
          [errMsg]="errorMessage"
          [successTitleTemplate]="successTitleTemplate"
          [successMsg]="successMessage"
          [success]="finalPage"
          [pageType]="appointmentConstant.APPOINTMENT"
          [widgetBookingInfo]="widgetBookingInfo"
          [manageAppointmentNowTemplate]="manageAppointmentNowTemplate"
          [downloadBookingDetailTemplate]="downloadBookingDetailTemplate"
          [successFullBookings]="successFullBookings"
          [showRefundNotice]="showRefundNotice"
          [refundNoticeKey]="refundNoticeKey"
          [refundTransactionId]="refundTransactionId"
        />

        <div class="additional-message mt-4" role="group" aria-label="Additional actions">
          @if (this.conferenceState?.uuid === undefined) {
            @if (hideBookingAgainButton()) {
              <calenso-button
                type="primary"
                id="cbw-book-next-appointment-button"
                #button
                (clickEvent)="booked = false; bookAppointmentAgain();"
                [widgetColorConf]="widgetColorConf"
                text="{{ 'appointments.finalpage.bookNextAppointment' | translate }}"
                aria-label="Book next appointment"
              />
            }
            @if (
              partnerService.hasFeature('is_external_success_page_forwarding_enabled') &&
              partner?.is_redirect_after_booking_enabled &&
              partner?.successful_booking_redirect_url &&
              partner?.redirect_after_booking_action === bookingRedirectionViews.BOOKING_SUCCESS_VIEW &&
              !globals.isInternal
            ) {
              <calenso-button
                type="primary"
                id="cbw-redirect-to-external-url-button"
                #button
                (clickEvent)="redirectToExternalUrl();"
                customCss="mt-2"
                [widgetColorConf]="widgetColorConf"
                text="{{ redirectionButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
                aria-label="Redirect to external url"
              />
            }

            @if (!finalPage) {
              <calenso-button
                type="primary"
                id="cbw-book-appointment-again-button"
                #button
                (clickEvent)="booked = false; bookAppointmentAgain();"
                [widgetColorConf]="widgetColorConf"
                text="{{ 'appointments.finalpage.bookAppointmentAgain' | translate }}"
                aria-label="Book appointment again"
              />
            }
          }

          @if (!isWhitelabel()) {
            <div class="mt-4 mb-4">
              <img
                alt="Logo"
                src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                width="100"
              />
            </div>
          }
        </div>
      </div>
    }

    <!--
      Nothing is bookable here (or the lookup failed), so the step bar and the wizard body would
      only render empty steps and a dead next button. Show the explanation on its own instead.
    -->
    @if (!booked && !showStripeRedirectionLoader && bookingBlocked()) {
      <app-new-alert
        type="warning"
        title="{{ (bookingLoadFailed() ? 'error_messages.something_went_wrong' : 'common.booking_unavailable') | translate }}"
        subTitle="{{ bookingLoadFailed() ? '' : ('common.booking_unavailable_description' | translate) }}"
        customClass="mt-3 mb-3"
      />
    }

    @if (!booked && !showStripeRedirectionLoader && !bookingBlocked()) {
      <form #appointmentForm="ngForm" onclick="void(0);" aria-label="Booking form">
        <div class="wizard-header" onclick="void(0);">
        </div>

        <!-- While an Adyen payment runs, everything that could change the booking or leave this step is
             locked; the payment's own "Cancel payment" is the way out. -->
        <nav class="wizard-navigation" onclick="void(0);" role="navigation" aria-label="Wizard navigation" [attr.inert]="adyenPaymentInFlight() ? '' : null" [class.cw-payment-locked]="adyenPaymentInFlight()">
          @if (formReseted && !noWorkers) {
            <div role="alert" aria-live="polite">
              <app-alert (click)="formReseted = false" text="{{ 'common.resetSuccess' | translate }}" />
            </div>
          }
          <app-appointment-navigation-bar
            (navigateToEvent)="navigateTo($event)"
            [(isServicesTabDisabled)]="isServicesTabDisabled"
            [appointmentState]="appointmentState"
            [cart]="cart"
            [hideResourceStep]="partner.hide_resource_step === 1 || hideResourceStep || partner.is_round_robin_feature_enabled === 1 || appointmentState.isCombiServiceSelected"
            [hideMeetingTypesStep]="hideMeetingTypesStep"
            [showAds]="showAds"
            [viewMode]="viewMode"
            [widgetColorConf]="widgetColorConf"
            [workersAvailable]="workersAvailable"
            [partner]="partner"
            [lang]="lang"
            [globals]="globals"
            [widgetTemplates]="widgetTemplates"
            [supportedWidgetLanguages]="partner?.supported_widget_languages"
            [langSwitcher]="langSwitcher"
            [appointmentFormStatus]="appointmentForm.valid"
          />
        </nav>

        <main>
          @switch (viewMode) {
            <!-- Tab 1: Customer type (Dynamically) -->
            @case (appointmentConstant.CUSTOMER_TYPE) {
              <section role="form" aria-labelledby="customer-type-section-title">
                <app-appointment-customer-profiles
                  [partner]="partner"
                  [lang]="lang"
                  [appointmentState]="appointmentState"
                  [widgetColorConf]="widgetColorConf"
                  [nextButtonTemplate]="nextButtonTemplate"
                  [customerProfileUuid]="customerProfileUuid"
                  [widgetTemplates]="widgetTemplates"
                  (navigateToEvent)="navigateTo($event.page)"
                />
              </section>
            }

            <!-- Tab 2: Store and Service selection -->
            @case (appointmentConstant.APPOINTMENT) {
              <section role="form" aria-labelledby="appointment-selection-section-title">
                <app-appointment-list
                  (disabledServiceTabEvent)="disabledServiceTab($event)"
                  (navigateToEvent)="resetCalendarData();navigateTo($event.page, $event.isFirstTime);"
                  (resetFormEvent)="resetForm()"
                  (serviceChangeEvent)="onServiceChange($event)"
                  (storeSelectedEvent)="onStoreSelected($event)"
                  (newStoresEvent)="onNewStoresEvent($event)"
                  (backToTourEvent)="backToTourEvent.emit($event)"
                  [(appointmentServicesByCat)]="appointmentServicesByCat"
                  [(appointmentState)]="appointmentState"
                  [lang]="lang"
                  [selectedStoreZipCode]="selectedStoreZipCode"
                  [partner]="partner"
                  [stores]="stores"
                  [widgetColorConf]="widgetColorConf"
                  [widgetConf]="widgetConf"
                  [hideStoreSelection]="
                    enteredAppointmentFromTour ||
                    (selectedStoreId && selectedStoreAvailable && !globals.isInternal) ||
                    (selectedStoreId && hideStoreSelection && globals.isInternal)
                  "
                  [previousButtonTemplate]="previousButtonTemplate"
                  [nextButtonTemplate]="nextButtonTemplate"
                  [globals]="globals"
                  [widgetTemplates]="widgetTemplates"
                  [subscriptionTypeId]="widgetConf.subscription.subscription_type_id"
                  [conferenceState]="conferenceState"
                  [isServicesLoading]="isServicesLoading"
                  [servicesResolved]="servicesResolved()"
                  [servicesLoadFailed]="servicesLoadFailed()"
                  [storesResolved]="storesResolved()"
                  [enteredAppointmentFromTour]="enteredAppointmentFromTour"
                />
              </section>
            }

            <!-- Tab 3: Worker selection -->
            @case (appointmentConstant.WORKER) {
              <div class="worker-tab">
                <app-appointment-worker-card
                  (navigateToEvent)="navigateTo($event)"
                  (resetFormEvent)="resetForm()"
                  (selectWorkerEvent)="selectWorker($event)"
                  (workerSelectedEvent)="onWorkerSelected()"
                  (workerExceptionEvent)="getExceptionalWorkers($event)"
                  [workerException]="exceptionWorkers"
                  [appointmentState]="appointmentState"
                  [showEgalWer]="partner.showEgalWer"
                  [widgetColorConf]="widgetColorConf"
                  [workersAvailable]="workersAvailable"
                  [lang]="lang"
                  [partner]="partner"
                  [viewMode]="viewMode"
                  [nextButtonTemplate]="nextButtonTemplate"
                  [previousButtonTemplate]="previousButtonTemplate"
                  [widgetTemplates]="widgetTemplates"
                  [subscriptionTypeId]="widgetConf.subscription.subscription_type_id"
                />
              </div>
            }

            <!-- Tab 4: meeting type selection (Dynamically) -->
            @case (appointmentConstant.MEETING_PROVIDERS) {
              <app-appointment-meeting-type
                [lang]="lang"
                [appointmentState]="appointmentState"
                [selectedWorkerIds]="selectedWorkerIds"
                [(userState)]="userState"
                [partner]="partner"
                [widgetTemplates]="widgetTemplates"
                [widgetColorConf]="widgetColorConf"
                [nextButtonTemplate]="nextButtonTemplate"
                [previousButtonTemplate]="previousButtonTemplate"
                [subscriptionTypeId]="widgetConf.subscription.subscription_type_id"
                (navigateToEvent)="navigateTo($event)"
                (hideMeetingTypesStepValue)="getHideMeetingTypesStepValue($event)"
              />
            }

            <!-- Tab 5: Date and Slot selection -->
            @case (appointmentConstant.DATE) {
              <div class="row cb-appointment-date-block">
                <div class="col-sm-12">
                  <h4
                    class="cbw-choose-date-title"
                    [innerHTML]="dateLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml: 'html'"
                  >
                  </h4>
                  @if (+partner.show_widget_calendar_notice === 1) {
                    @if (this.showWidgetCalendarOverwriteNotice.length) {
                      <div class="alert alert-success cbw-calendar-highlight-notice-alert">
                        @for (highlight of showWidgetCalendarOverwriteNotice; track $index) {
                          <div [innerHTML]="highlight | translation: 'calendar_hint_banner_text': lang" ></div>
                        }
                      </div>
                    } @else if (widgetCalendarHighlightsNoticeText && (widgetCalendarHighlightsNoticeText | translation: templateContent.TEMPLATE_CONTENT: lang)?.trim()) {
                      <div class="alert alert-success cbw-calendar-highlight-notice-alert">
                        <div [innerHTML]="(widgetCalendarHighlightsNoticeText | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml: 'html'"></div>
                      </div>
                    }
                  }
                </div>

                <div class="col-lg-6 col-md-6 col-xs-6 col-xxs-12 cbw-calender-picker-wrapper">
                  <app-calendar-picker
                    (dayClickedEvent)="dayClicked($event)"
                    (markExceptionDaysEvent)="markExceptionDays($event)"
                    (viewDateChangedEvent)="viewDateChanged($event)"
                    [(viewDate)]="viewDate"
                    [calendarPreselectedDate]="calendarPreselectedDate"
                    [calendarLoaded]="calendarLoaded"
                    [calendarSlotsCountList]="calendarSlotsCountList"
                    [days]="days"
                    [disablePrev]="disablePrev"
                    [futureBookingThreshold]="partner.future_booking_threshold_appointments"
                    [noFreeDates]="noAppointments"
                    [widgetColorConf]="widgetColorConf"
                    [workerSetter]="selectedWorker"
                    [lang]="lang"
                    [partner]="partner"
                    [conferenceState]="conferenceState"
                    [calendarHighlightData]="calendarHighlightData"
                    [appointmentState]="appointmentState"
                    [globals]="globals"
                    [timezones]="timezones"
                    [(userState)]="userState"
                    (onTimezoneChange)="onTimezoneChange($event)"
                  />

                  @if (partner.show_worker_selection_on_date_step === 1) {
                    <div class="show-workers-list-note cbw-show-workers-list-note">
                      {{ 'appointments.step3.workerSelectLinkPrefix' | translate }}
                      <a href="javascript:void(0);" (click)="showWorkersListOnDateStepFn()">
                        {{ (showWorkersListOnDateStep ? 'appointments.step3.workerSelectHideAllLinkPostfix' : 'appointments.step3.workerSelectShowAllLinkPostfix') | translate }}
                      </a>
                    </div>
                  }

                  @if (globals.debugMode) {
                    <div class="troubleshoot-mode-toggle cbw-troubleshoot-mode-toggle">
                      @if (!troubleshootingModeEnabled) {
                        {{ 'appointments.step3.troubleshooting_mode_note_pre' | translate }}
                        <a href="javascript:void(0);" (click)="toggleTroubleshootingMode()">{{ 'appointments.step3.troubleshooting_mode_link' | translate }}</a>
                        {{ 'appointments.step3.troubleshooting_mode_note_post' | translate }}
                      } @else {
                        <!-- Adjacent on purpose: each key carries its own spacing, so a language
                             can place the verb before or after the link. -->
                        {{ 'appointments.step3.turn_off_troubleshooting_pre' | translate
                        }}<a href="javascript:void(0);" (click)="toggleTroubleshootingMode()">{{
                          'appointments.step3.turn_off_troubleshooting_link' | translate
                        }}</a>{{ 'appointments.step3.turn_off_troubleshooting_post' | translate }}
                      }
                    </div>

                    @if (troubleshootingModeEnabled && debugCommonNotes?.length) {
                      <div class="troubleshoot-mode-commom-notes">
                        <b>{{ 'appointments.step3.common_notes' | translate }}:</b>
                        <ul class="troubleshoot-mode-commom-notes-list">
                          @for (note of debugCommonNotes; track note) {
                            <li
                              class="troubleshoot-mode-commom-note"
                              [innerHTML]="note | trustHtml: 'html'"
                            ></li>
                          }
                        </ul>
                      </div>
                    }
                  }
                </div>

                <div class="col-lg-6 col-md-6 col-xs-6 col-xxs-12 termin-container cbw-appointment-slots-wrapper">
                  @if (showWorkersListOnDateStep) {
                    <div class="worker-selection-on-date-step cbw-worker-selection-on-date-step">
                      <label class="worker-selection-label cbw-worker-selection-label">
                        {{ 'appointments.step3.workerSelectLable' | translate }}
                      </label>
                      <ng-select
                        name="worker_selection_on_date_step"
                        class="wroker-select-on-date-step"
                        [searchFn]="customWorkerSearchFn"
                        [clearable]="false"
                        [items]="workersAvailableWithAnyoneOption"
                        (change)="selectWorker($event?.id, true)"
                      >
                        <ng-template ng-option-tmp let-worker="item">
                          <div class="worker">
                            <div class="avatar-wrapper cbw-avatar-wrapper">
                              <img #image class="avatar cbw-avatar" height="35" width="35" alt="Worker avatar"
                                [src]="worker.avatar !== null ? workerAvatarUrl + worker.uuid + '/thumb_' + worker.avatar : baseUrl + '/img/sample-avatar.png'"
                                (error)="image.src= baseUrl + '/img/sample-avatar.png'" />
                            </div>

                            @if (worker.id === 0) {
                              <div>
                                <div class="worker-name cbw-worker-name"
                                  [innerHTML]="(widgetAnyoneLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml">
                                </div>

                                <div class="worker-function cbw-worker-function"
                                  [innerHTML]="(widgetAnyoneDescTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml">
                                </div>
                              </div>
                            }

                            @if (worker.id !== 0) {
                              <div>
                                <div class="worker-name cbw-worker-name">
                                  {{ worker | translation: 'resource_name': lang }}
                                </div>
                                @if (worker.is_resource === 0 && (worker | translation: 'job_title': lang); as jobTitle) {
                                  <div
                                  class="worker-function cbw-worker-function"
                                  [innerHTML]="jobTitle | trustHtml">
                                  </div>
                                }

                                @if (worker.is_resource === 1 && (worker | translation: 'description': lang); as description) {
                                  <div
                                  class="worker-function cbw-worker-function"
                                  [innerHTML]="description | trustHtml"
                                  >
                                  </div>
                                }

                                @if (worker?.attributes?.length) {
                                  @for (attribute of worker.attributes; track attribute.uuid) {
                                    @if (attribute.type === 'select') {
                                      <div class="attribute-container cbw-attribute-container">
                                        <div class="cbw-attribute">
                                          {{ attribute | translation: 'name': lang }}:
                                        </div>
                                        <div class="attribute-value-section">
                                          @for (value of attribute.attributes_values; track value.uuid; let last = $last) {
                                            <div class="attribute-value-img">
                                              @if (value.icon_url !== null) {
                                                <img
                                                  #image
                                                  class="cbw-attribute-icon"
                                                  alt="{{ value.value }}"
                                                  src="{{ value.icon_url }}"
                                                  (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                                                />
                                              }
                                              <div class="cbw-attribute-value">
                                                {{ value | translation: 'value' : lang }}
                                                @if (!last) { | }
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    } @else {
                                      <div class="cbw-attribute cbw-attribute-container">
                                        {{ attribute | translation: 'name': lang }}:
                                        @if (attribute.attributes_values?.length) {
                                          {{ +attribute.attributes_values[0].value === 1 ? ( 'yes' | translate ): ( 'no' | translate ) }}
                                        }
                                      </div>
                                    }
                                  }
                                }
                              </div>
                            }
                          </div>
                        </ng-template>

                        <ng-template ng-label-tmp let-worker="item">
                          <div class="worker">
                            <div class="avatar-wrapper cbw-avatar-wrapper">
                              <img #image class="avatar cbw-avatar" height="35" width="35" alt="Worker avatar"
                                [src]="worker.avatar !== null ? workerAvatarUrl + worker.uuid + '/thumb_' + worker.avatar : baseUrl + '/img/sample-avatar.png'"
                                (error)="image.src= baseUrl + '/img/sample-avatar.png'" />
                            </div>

                            @if (worker.id === 0) {
                              <div class="worker-name cbw-worker-name"
                                [innerHTML]="(widgetAnyoneLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                              ></div>
                            } @else {
                              <div class="worker-name cbw-worker-name">
                                {{ worker | translation: 'resource_name': lang }}
                              </div>
                            }
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  }

                  @if (!this.appointmentState?.date && showAppointmentSlotGhostElement !== 1 && showAppointmentSlotGhostElement !== 2 && calendarDate) {
                    <div class="alert cbw-date-select-hint-alert">
                      {{ selectDayInCalendarMsgTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
                    </div>
                  }

                  @if (showAppointmentSlotGhostElement === 1) {
                    <div class="skeleton-box-card">
                      <div class="row">
                        @if (widgetGroups.length) {
                          @for (slotGhost of slotGhostElementsCount; track $index) {
                            <div class="d-none d-sm-block col-sm-3 mb-3">
                              <div class="d-flex stats-card">
                                <div class="skeleton-animation w-100 d-flex justify-content-center flex-column align-items-center">
                                  <div class="w-100">
                                    <div class="stat-box-1 mb-1"></div>
                                    <div class="stat-box-1"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        }

                        @for (appointmentSlotGhostElement of appointmentSlotGhostElements; track appointmentSlotGhostElement) {
                          <div class="col-xs-12 col-sm-6 mb-3" [ngClass]="{'normal-slots': !widgetGroups.length}">
                            <div class="d-flex stats-card">
                              <div class="skeleton-animation w-100 d-flex justify-content-center flex-column align-items-center">
                                <div class="w-100">
                                  <div class="stat-box-1"></div>
                                  <div class="stat-box mt-1"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }

                  @if (showAppointmentSlotGhostElement === 2) {
                    <!-- Reservation related errors start -->
                    @if (slotAlreadyReservedByOtherError) {
                      <div class="reservation-error-message cbw-reservation-error-message">
                        {{ 'alert_messages.slot_already_reserved_by_other_error' | translate }}
                      </div>
                    }
                    <!-- Reservation related errors end -->

                    @if (showBookableDateNotAvailableIssue) {
                      @if (!automationBookingDatesLimitReached) {
                        <div class="no-bookable-error-message">
                          {{ noBookableDatesTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
                        </div>
                      }

                      @if (automationBookingDatesLimitReached) {
                        <div class="no-bookable-error-message">
                          {{ 'alert_messages.no_bookable_dates_reached_message' | translate: { month: (viewDate | date:'MMMM' | translate) } }}
                        </div>
                      }

                      @if (!automationBookingDatesLimitReached) {
                        <div class="mt-2">
                          <calenso-button
                            type="secondary"
                            #button
                            (clickEvent)="autoLoadBookableDates()"
                            [widgetColorConf]="widgetColorConf"
                            placement="left"
                            text="{{ yesSearchButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}"
                          />
                        </div>
                      }
                    }

                    @if (!showBookableDateNotAvailableIssue && appointmentState?.date) {
                      <app-appointment-card
                        [appointmentState]="appointmentState"
                        [cart]="cart"
                        [(freeAppointments)]="freeAppointments"
                        [(noAppointments)]="noAppointments"
                        [partner]="partner"
                        [lang]="lang"
                        [widgetColorConf]="widgetColorConf"
                        [showEgalWer]="partner.showEgalWer"
                        [freeAppointmentsCount]="freeAppointmentsCount"
                        [widgetTemplates]="widgetTemplates"
                        [conferenceState]="conferenceState"
                        [showAppointmentSlots]="showAppointmentSlots"
                        (updateCartEvent)="updateCart($event)"
                        (gotoNextPageEvent)="reserveAppointments()"
                      />
                    }
                  }
                </div>
              </div>

              @if (showDateStepValidationError() && cart.length <= 0) {
                <div
                  id="cbw-date-validation-error"
                  class="cbw-global-step-error cbw-date-step-error"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div class="cbw-step-error-text">
                    {{ dateStepErrorTemplate ? (dateStepErrorTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : ('alert_messages.next_step_error_date' | translate) }}
                  </div>
                </div>
              }

              <div class="wizard-footer">
                <div class="row margin-x-0">
                  <div class="col-4 d-flex align-items-center justify-content-start">
                    @if (
                      !isWhitelabel() &&
                      (!globals.isInternal || partner?.widget_show_lead_creation_button !== 1 || partner.enable_store_postcode_feature !== 1)
                    ) {
                      <div class="d-md-none">
                        <img src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}" alt="Logo" width="100">
                      </div>
                    }

                    @if (globals.isInternal && partner?.widget_show_lead_creation_button === 1 && partner.enable_store_postcode_feature === 1) {
                      <calenso-button
                        type="secondary"
                        #button
                        text="{{ 'appointments.step1.expert_cap_button_label' | translate }}"
                        (clickEvent)="configureCustomerLinkEventHandler()"
                        [widgetColorConf]="widgetColorConf"
                      />
                    }
                  </div>

                  <div class="col-4 d-flex align-items-center justify-content-center">
                    @if (!isWhitelabel()) {
                      <div class="d-none d-md-block">
                        <img src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}" alt="Logo" width="100">
                      </div>
                    }
                  </div>

                  <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
                    <calenso-button
                      type="secondary"
                      id="cbw-prev-button"
                      #button
                      (clickEvent)="backButtonClicked = true; navigateTo(appointmentConstant.WORKER)"
                      [disabled]="disableDatePagePreviousButton"
                      [widgetColorConf]="widgetColorConf"
                      placement="left"
                      [text]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                    />

                    <calenso-button
                      type="primary"
                      id="cbw-next-button"
                      class="ms-2"
                      #button
                      (clickEvent)="onDateNextButtonClick()"
                      [isloading]="reservingAppointment"
                      [disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : cart.length <= 0"
                      [widgetColorConf]="widgetColorConf"
                      placement="right"
                      [text]="nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                      [attr.aria-describedby]="showDateStepValidationError() && cart.length <= 0 ? 'cbw-date-validation-error' : null"
                    />
                  </div>
                </div>
              </div>
            }

            <!-- Tab 6: Personal-Data & Cart-Overview -->
            @case (appointmentConstant.PERSONAL_INFO) {
              <div class="summary-tab">
                <div class="row inline-block cb-appointment-summary-block">
                  <!-- Start of personal-data container  -->
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4 cbw-personal-data-wrapper" [attr.inert]="adyenPaymentInFlight() ? '' : null" [class.cw-payment-locked]="adyenPaymentInFlight()">
                    @if (!isCustomFieldsLoaded) {
                      <app-cw-new-card
                        [showBody]="true"
                        [showHeader]="true"
                        customCardClass="mb-4"
                      >
                        <div header>
                          <app-cw-card-header title="" subtitle="" />
                        </div>
                        <div body class="my-4">
                          <div class="skeleton-box-card">
                            <div class="row">
                              @for (appointmentSlotGhostElement of appointmentSlotGhostElements; track appointmentSlotGhostElement) {
                                <div class="col-md-12 mb-4">
                                  <div class="d-flex stats-card">
                                    <div class="skeleton-animation w-100 d-flex justify-content-center flex-column">
                                      <div>
                                        <div class="stat-box-2"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </app-cw-new-card>
                    }

                    @if (cart?.length && isCustomFieldsLoaded) {
                      <app-personal-data-form
                        (updateCustomerSelectedEvent)="updateCustomerSelected($event)"
                        (updateUserStateEvent)="updateUserState($event)"
                        [(customFieldValues)]="customFieldValues"
                        [(userState)]="userState"
                        [customFields]="appointmentCustomFields"
                        [globals]="globals"
                        [hideLoginOnBookingSite]="partner.hide_login_on_bookingsite"
                        [lang]="lang"
                        [partner]="partner"
                        [type]="appointmentConstant.APPOINTMENT"
                        [courtesyForm]="courtesyForm"
                        [appointmentCart]="cart"
                        [widgetTemplates]="widgetTemplates"
                        [widgetColorConf]="widgetColorConf"
                        [customFieldValuesLSNameKey]="CUSTOMFIELDS_LS_NAME"
                        [selectedJsonCustomFields]="selectedJsonCustomFields"
                        [selectedJsonCustomerDetail]="selectedJsonCustomerDetail"
                        [selectedJsonBrokerDetail]="selectedJsonBrokerDetail"
                        [userDataLSNameKey]="USER_LS_NAME"
                        [meeting_type_id]="meeting_type_id"
                        [customer_notification_preference]="customer_notification_preference"
                        [appointmentState]="appointmentState"
                        [stores]="stores"
                        [conferenceState]="conferenceState"
                        [brokerState]="brokerState"
                        [bookingType]="bookingType"
                        [customer]="customer"
                      />
                    }
                  </div>
                  <!-- End of personal-data container component -->

                  <!-- Start of payment method container -->
                  @if (partner?.split_personal_form_and_summary_in_widget === 0 && (totalCartPrice > 0 && isServiceOnlinePaymentEnabled === 1)) {
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                      <ng-container *ngTemplateOutlet="paymentMethodsTemplate" />
                    </div>
                  }
                  <!-- End of payment method container -->

                  <!-- Start of cart container -> supposed to be its own component -->
                  @if (partner?.split_personal_form_and_summary_in_widget === 0 || globals.isInternal) {
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4 cbw-appointment-cart-overview-wrapper" [attr.inert]="adyenPaymentInFlight() ? '' : null" [class.cw-payment-locked]="adyenPaymentInFlight()">
                      <ng-container *ngTemplateOutlet="cartOverviewTemplate; context: { mode: appointmentConstant.PERSONAL_INFO}"  />
                    </div>
                  }
                  <!-- End of cart container component -->
                </div>

                <!-- Tab 4 Pagination -->
                <div class="row margin-x-0 final-page-buttons-box">
                  @if (partner?.split_personal_form_and_summary_in_widget === 0) {
                    @if (bookingErrorMessage) {
                      <div class="col-sm-12 mt-2">
                      <app-alert [text]="bookingErrorMessage" type="danger" id="booking-error-message"/>
                      </div>
                    }
                    @if (showRefundNotice) {
                      <div class="col-sm-12 mt-2">
                        <app-alert
                          type="info"
                          [text]="refundNoticeKey | translate: { transactionId: refundTransactionId }"
                        />
                      </div>
                    }

                    @if (paymentType === paymentTypes.PAYPAL && !paypalOrderDetail) {
                      <div class="col-sm-12 mt-2">
                        <app-alert text="{{ 'summary_page_translations.paypal_warning_msg' | translate }}" type="warning"/>
                      </div>
                    }
                  }

                  <div class="col-sm-12">
                    <div class="wizard-footer clearfix">
                      <div class="row">
                        <div class="col-4 d-flex align-items-center justify-content-start">
                          @if (!isWhitelabel()) {
                            <div class="d-md-none">
                              <img
                                alt="Logo"
                                src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                                width="100"
                              />
                            </div>
                          }
                        </div>

                        <div class="col-4 d-flex align-items-center justify-content-center">
                          @if (!isWhitelabel()) {
                            <div class="d-none d-md-block">
                              <img
                                alt="Logo"
                                src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                                width="100"
                              />
                            </div>
                          }
                        </div>

                        <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
                          <calenso-button
                            type="secondary"
                            id="cbw-prev-button"
                            #button
                            (clickEvent)="navigateTo(appointmentConstant.DATE)"
                            [disabled]="adyenPaymentInFlight()"
                            [widgetColorConf]="widgetColorConf"
                            placement="left"
                            [text]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                          />

                          @if (!hideBookingButton) {
                            @if (partner?.split_personal_form_and_summary_in_widget === 1) {
                              <calenso-button
                                type="primary"
                                id="cbw-next-button"
                                class="ms-2"
                                #button
                                (clickEvent)="validatePersonalFormAndNavigateToSummaryStep()"
                                [widgetColorConf]="widgetColorConf"
                                placement="right"
                                [text]="nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                              />
                            } @else {
                              <calenso-button
                                type="primary"
                                class="ms-2"
                                #button
                                id="cbw-booking-finish"
                                (clickEvent)="submitBooking()"
                                [disabled]="disableBookingButton || isInvoiceAddressFormBlockingBooking || payAgainRequired() || adyenPaymentInFlight()"
                                [widgetColorConf]="widgetColorConf"
                                placement="right"
                                [isloading]="bookButtonLoader"
                                [text]="bookButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                                [title]="stripeElementLoading ? ('payment_components.stripe_not_ready' | translate) : null"
                              />
                            }
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Tab 7: Summary -->
            @case (appointmentConstant.SUMMARY) {
              @if (showSummaryDetails) {
                <!-- Start of summary details sections -->
                <div class="booking-still-open-note cbw-booking-still-open-note" [attr.aria-label]="'Booking still open note'" role="region">
                  <app-alert
                    [text]="bookingIncompleteNoteOnSummaryStep | translation: templateContent.TEMPLATE_CONTENT: lang"
                    type="warning"
                  />
                </div>

                <div class="appointment-data-review-block cbw-appointment-data-review-block" [attr.aria-label]="'Appointment data review'" role="region" [attr.inert]="adyenPaymentInFlight() ? '' : null" [class.cw-payment-locked]="adyenPaymentInFlight()">
                  <div class="appointment-personal-info-block cbw-appointment-personal-info-block" [attr.aria-label]="'Appointment personal info'" role="region">
                    <app-cw-new-card showHeader="true">
                      <div header class="heading cbw-heading" [attr.aria-label]="'Appointment personal info heading'">
                        <calio-mat-icon class="icons cbw-person-icon" iconType="person-f" height="26px" width="26px" />
                        <div class="heading-text" [innerHTML]="(summaryPagePersonalInfoHeading | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"></div>
                        <calio-mat-icon
                          class="edit-personal-info icons cbw-edit-icon cursor-pointer"
                          iconType="edit"
                          height="20px"
                          width="20px"
                          [attr.aria-label]="'Edit personal info'"
                          (click)="navigateTo(appointmentConstant.PERSONAL_INFO)"
                        />
                      </div>

                      <div body class="personal-info cbw-personal-info">
                        <!-- Gender -->
                        @if (summaryDetails?.gender) {
                          <div class="details cbw-details">
                            @if (summaryDetails.gender === 'm') {
                              {{ 'summary_page_translations.mr' | translate }}
                            } @else if (summaryDetails.gender === 'f') {
                              {{ 'summary_page_translations.ms' | translate }}
                            } @else {
                              {{ 'summary_page_translations.other' | translate }}
                            }
                          </div>
                        }

                        <!-- Prename & Lastname -->
                        @if (summaryDetails?.prename || summaryDetails?.lastname) {
                          <div class="details cbw-details">
                            <!-- Title -->
                            @if (summaryDetails?.title) {
                              @switch(summaryDetails.title) {
                                @case (1) {
                                  <span>{{ "Dr. " }}</span>
                                }
                                @case (2) {
                                  <span>{{ "Dr. med. " }}</span>
                                }
                                @case (3) {
                                  <span>{{ "Prof. " }}</span>
                                }
                                @case (4) {
                                  <span>{{ "Prof. Dr. " }}</span>
                                }
                              }
                            }

                            <!-- Prename -->
                            @if (summaryDetails?.prename) {
                              <span [innerHTML]="summaryDetails.prename + ' ' | trustHtml: 'html'"></span>
                            }

                            <!-- Lastname -->
                            @if (summaryDetails?.lastname) {
                              <span [innerHTML]="summaryDetails.lastname | trustHtml: 'html'"></span>
                            }
                          </div>
                        }

                        <!-- Address -->
                        @if (summaryDetails?.street || summaryDetails?.zip || summaryDetails?.city || summaryDetails?.country) {
                          <div class="details address cbw-details">
                            <span class="cbw-summary-location-address whitespace-pre-line">
                                @let addressInput = {
                                  street: summaryDetails.street,
                                  zip: summaryDetails.zip,
                                  city: summaryDetails.city,
                                  country: summaryDetails.country | translation: 'name' : lang,
                                  country_code: summaryDetails.country?.identifier
                                };
                                {{ addressInput | addressFormat }}
                            </span>
                          </div>
                        }

                        <!-- Email -->
                        @if (summaryDetails?.email) {
                          <div class="details cbw-details">
                            <span>{{ 'customer.eMail.label' | translate }}</span>:
                            <span [innerHTML]="summaryDetails.email | trustHtml: 'html'"></span>
                          </div>
                        }

                        <!-- Mobile -->
                        @if (summaryDetails?.mobile) {
                          <div class="details cbw-details">
                            <span
                              [innerHTML]="((widgetTemplates | calioMeetingTemplate: { id: templateConstant.SHOW_MOBILE_ON_WIDGET, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                            ></span>:
                            <span [innerHTML]="summaryDetails.mobile | trustHtml: 'html'"></span>
                          </div>
                        }

                        <!-- Phone -->
                        @if (summaryDetails?.phone) {
                          <div class="details cbw-details">
                            <span
                              [innerHTML]="((widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PHONENUMBER_LABEL_TEMPLATE, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                            ></span>:
                            <span [innerHTML]="summaryDetails.phone | trustHtml: 'html'"></span>
                          </div>
                        }

                        @if (appointmentCustomFields?.length) {
                          <div class="booking-questions cbw-booking-questions">
                            @for (customField of appointmentCustomFields; track customField) {
                              @if (
                                summaryDetails.customFieldValues?.[customField.id] &&
                                (summaryDetails.customFieldValues?.[customField.id]?.options?.length || summaryDetails.customFieldValues?.[customField.id]?.value !== undefined)
                              ) {
                                <ng-container *ngTemplateOutlet="customFieldSummaryView; context: { customField: customField }" />
                                @if (customField?.customFieldDependencies?.length) {
                                  @for (dependentCustomField of customField.customFieldDependencies; track dependentCustomField) {
                                    @if (
                                      summaryDetails.customFieldValues?.[dependentCustomField.id] &&
                                      (summaryDetails.customFieldValues?.[dependentCustomField.id]?.options || summaryDetails.customFieldValues?.[dependentCustomField.id]?.value)
                                    ) {
                                      <ng-container *ngTemplateOutlet="customFieldSummaryView; context: { customField: dependentCustomField }" />
                                    }
                                  }
                                }
                              }
                            }
                          </div>

                          <ng-template #customFieldSummaryView let-customField="customField">
                            @if (customField.type !== this.bookingCustomFieldTypes.INFORMATION) {
                              <div class="question cbw-question" [attr.aria-label]="'Custom field question'">
                                <span class="label cbw-label">
                                  @if (!(customField | translation: 'title': lang)) {
                                    <span [innerHTML]="(customField | translation: 'label': lang) | replaceQuestionmarkFromEndOfString | trustHtml: 'html' "></span>:
                                  } @else {
                                    <span [innerHTML]="(customField | translation: 'title': lang) | replaceQuestionmarkFromEndOfString | trustHtml: 'html'"></span>
                                    <span class="light-label" [innerHTML]="(' (' + (customField | translation: 'label': lang) + ')') | replaceQuestionmarkFromEndOfString | trustHtml: 'html'"></span>:
                                  }
                                </span>
                                @if ([bookingCustomFieldTypes.SELECT, bookingCustomFieldTypes.RADIO, bookingCustomFieldTypes.IMAGE_SELECT,
                                  bookingCustomFieldTypes.CARD_SELECT].includes(customField.type)) {
                                  <span class="value cbw-value">
                                    @for (option of summaryDetails.customFieldValues[customField.id].options; track option; let i = $index; let l = $count) {
                                      @if (option?.title) {
                                        <span>
                                          {{ option | translation: 'title': lang }}
                                          ({{ option | translation: 'label': lang }})@if ((l-(i+1)) > 0) {<span>, </span>}
                                        </span>
                                      } @else {
                                        <span>
                                          {{ option | translation: 'label': lang }}@if ((l-(i+1)) > 0) {<span>, </span>}
                                        </span>
                                      }
                                    }
                                  </span>
                                } @else if (customField.type === this.bookingCustomFieldTypes.CHECKBOX) {
                                  <span class="value cbw-value">
                                    {{ ['true', '1', 1, true].includes(summaryDetails.customFieldValues[customField.id].value) ? ('yes' | translate) : ('no' | translate)  }}
                                  </span>
                                } @else if (![
                                  bookingCustomFieldTypes.WORKER_SELECT,
                                  bookingCustomFieldTypes.SELECT,
                                  bookingCustomFieldTypes.CHECKBOX,
                                  bookingCustomFieldTypes.FILE,
                                  bookingCustomFieldTypes.RADIO,
                                  bookingCustomFieldTypes.IMAGE_SELECT,
                                  bookingCustomFieldTypes.CARD_SELECT,
                                  bookingCustomFieldTypes.NUMBER_SELECT
                                  ].includes(customField?.type)) {
                                  <span class="value cbw-value">
                                    {{ summaryDetails.customFieldValues[customField.id].value }}
                                  </span>
                                } @else if (customField.type === bookingCustomFieldTypes.NUMBER_SELECT) {
                                  <span class="value cbw-value">
                                    @for (option of summaryDetails.customFieldValues[customField.id].options; track option; let i = $index;) {
                                      <span>
                                        @if (option?.option?.title) {
                                          <span>
                                            {{ option?.option | translation: 'title': lang}}
                                            ({{ option?.option | translation: 'label': lang}}):
                                          </span>
                                        } @else {
                                          <span>
                                            {{ option?.option | translation: 'label': lang}}:
                                          </span>
                                        }
                                        <span class="ps-1">
                                          {{ option?.value }}
                                        </span>
                                      </span>
                                    }
                                  </span>
                                }
                              </div>
                            }
                          </ng-template>
                        }
                      </div>
                    </app-cw-new-card>
                  </div>

                  <div class="cart-summary-block cbw-cart-summary-block" [attr.aria-label]="'Cart summary'" role="region">
                    <app-cw-new-card showHeader="true">
                      <div header class="d-flex justify-content-between align-items-center cbw-cart-summary-header flex-wrap gap-2 w-100">
                        <div class="heading cbw-heading" [attr.aria-label]="'Cart summary heading'">
                          <calio-mat-icon class="icons cbw-event-icon" iconType="event-f" height="26px" width="26px" />
                          <div class="heading-text" [innerHTML]="(summaryPageCartDetailsHeading | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"></div>
                        </div>
                        <div class="cbw-reservation-countdown-container">
                          <app-reservation-countdown
                            [partner]="partner"
                            [showReservationCountdown]="true"
                            [cart]="cart"
                            (reservationExpiredEvent)="onReservationExpired($event)"
                          />
                        </div>
                      </div>

                      <div body class="personal-info cbw-personal-info">
                        <ng-container *ngTemplateOutlet="cartOverviewTemplate; context: { mode: appointmentConstant.SUMMARY }" />
                      </div>
                    </app-cw-new-card>
                  </div>
                </div>
                <!-- End of summary details sections -->
              }

              <!-- Start of payment method container -->
              @if (totalCartPrice > 0 && isServiceOnlinePaymentEnabled === 1) {
                <div class="mt-4 summary-payment-methods" [attr.aria-label]="'Summary payment methods'">
                  <ng-container *ngTemplateOutlet="paymentMethodsTemplate" />
                </div>
              }
              <!-- End of payment method container -->

              <div class="row margin-x-0 final-page-buttons-box">
                @if (bookingErrorMessage) {
                  <div class="col-sm-12 mt-2">
                    <app-alert [text]="bookingErrorMessage" type="danger" [attr.aria-label]="'Booking error message'" id="booking-error-message"/>
                  </div>
                }
                @if (showRefundNotice) {
                  <div class="col-sm-12 mt-2">
                    <app-alert
                      type="info"
                      [text]="refundNoticeKey | translate: { transactionId: refundTransactionId }"
                    />
                  </div>
                }

                @if (paymentType === paymentTypes.PAYPAL && !paypalOrderDetail) {
                  <div class="col-sm-12 mt-2">
                    <app-alert text="{{ 'summary_page_translations.paypal_warning_msg' | translate }}" type="warning" [attr.aria-label]="'Paypal warning message'"/>
                  </div>
                }

                <div class="col-sm-12" [attr.aria-label]="'Navigation buttons'">
                  <div class="wizard-footer clearfix">
                    <div class="row">
                      <div class="col-4 d-flex align-items-center justify-content-start">
                        @if (!isWhitelabel()) {
                          <div class="d-md-none">
                            <img
                              alt="Logo"
                              src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                              width="100"
                            />
                          </div>
                        }
                      </div>

                      <div class="col-4 d-flex align-items-center justify-content-center">
                        @if (!isWhitelabel()) {
                          <div class="d-none d-md-block">
                            <img
                              alt="Logo"
                              src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                              width="100"
                            />
                          </div>
                        }
                      </div>

                      <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
                        <calenso-button
                          type="secondary"
                          id="cbw-prev-button"
                          #button
                          (clickEvent)="navigateTo(appointmentConstant.PERSONAL_INFO)"
                          [disabled]="adyenPaymentInFlight()"
                          [widgetColorConf]="widgetColorConf"
                          placement="left"
                          [text]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                          [attr.aria-label]="'Previous button'"
                        />

                         @if (!hideBookingButton) {
                          <calenso-button
                            type="primary"
                            class="ms-2"
                            #button
                            id="cbw-booking-finish"
                            placement="right"
                            [text]="bookButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
                            [widgetColorConf]="widgetColorConf"
                            [isloading]="bookButtonLoader"
                            [disabled]="disableBookingButton || isInvoiceAddressFormBlockingBooking || payAgainRequired() || adyenPaymentInFlight()"
                            (clickEvent)="submitBooking()"
                            [attr.aria-label]="'Book button'"
                            [title]="stripeElementLoading ? ('payment_components.stripe_not_ready' | translate) : null"
                          />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Start of cross selling service -->
              @if (
                partner.show_cross_selling_services_on_summary_step === 1 &&
                crossSellingServices.length
              ) {
                <hr />
                <div class="cross-selling-services-block cbw-cross-selling-services-block" [attr.aria-label]="'Cross selling services'" [attr.inert]="adyenPaymentInFlight() ? '' : null" [class.cw-payment-locked]="adyenPaymentInFlight()">
                  <app-cw-new-card showHeader="true">
                    <div header class="heading cbw-heading" [attr.aria-label]="'Cross selling services heading'">
                      <calio-mat-icon class="icons cbw-event-icon" iconType="plus-f" height="20px" width="20px" style="width: 26px;" />
                      <div class="heading-text"
                        [innerHTML]="(summaryPageCrossServiceHeading | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                      ></div>
                    </div>

                    <div body class="services-list cbw-services-list">
                      <app-cross-selling-services
                        [crossSellingServices]="crossSellingServices"
                        [lang]="lang"
                        [partner]="partner"
                        [widgetColorConf]="widgetColorConf"
                        [addCrossServiceToCartButtonText]="addCrossServiceToCartButtonText"
                        (serviceChangeEvent)="onServiceChange($event); navigateTo(appointmentConstant.WORKER);"
                      />
                    </div>
                  </app-cw-new-card>
                </div>
              }
              <!-- End of cross selling service -->
            }
          }
        </main>
      </form>
    }
  </div>
</div>

<ng-template #paymentMethodsTemplate>
  <app-cw-payment-methods
    class="cbw-payment-methods"
    [isFormValid]="appointmentForm?.valid && formService.imageUploaded"
    [isPaymentInProgress]="isPaymentInProgress"
    [isStripeEnabled]="isStripeEnabled"
    [isOnlinePaymentEnabled]="!!isServiceOnlinePaymentEnabled"
    [isOnlinePaymentMandatory]="isOnlinePaymentMandatory"
    [isBexioEnabled]="isBexioEnabled"
    [isExternalInvoiceEnabled]="isExternalInvoiceEnabled"
    [isInvoiceAddressMandatory]="isInvoiceAddressMandatory(partner?.needCustomerAddress, userState)"
    [isStoreEnabled]="isStoreEnabled"
    [isLexOfficePaymentTypeEnabled]="isLexOfficePaymentTypeEnabled"
    [isPaypalEnabled]="isPaypalEnabled"
    [isSaferpayEnabled]="isSaferpayEnabled"
    [isAdyenEnabled]="isAdyenEnabled"
    [storeId]="appointmentState.store"
    [bookingLinkUuid]="conferenceState?.uuid"
    [isCombiServiceSelected]="appointmentState.isCombiServiceSelected"
    [(paymentType)]="paymentType"
    [partner]="partner"
    [lang]="lang"
    [widgetType]="widgetConstant.APPOINTMENT"
    [paypalSetting]="paypalSetting"
    [customFieldsAddonsPrice]="customFieldsAddonsPrice"
    [totalAmount]="cartTotalInclVat()"
    [courtesyForm]="courtesyForm"
    [widgetTemplates]="widgetTemplates"
    [appointmentServicesAvailable]="appointmentServicesAvailable"
    [cart]="cart"
    [userState]="userState"
    [preApplyCoupon]="preApplyCoupon"
    [coupon]="coupon"
    [finalCouponDiscount]="finalCouponDiscount"
    [priceAfterCouponReduction]="priceAfterCouponReduction"
    [stripeConnectedAccountId]="stripeConnectedAccountId"
    [defaultPaymentType]="defaultPaymentType"
    [storageComplete]="storageComplete"
    (changePaymentTypeEvent)="onChangePaymentType($event)"
    (couponFailedEvent)="onCouponFailedEvent($event)"
    (couponSuccessEvent)="onCouponSuccessEvent($event)"
    (resetStripeTokenEvent)="onResetStripeTokenEvent($event)"
    (stripeSuccessfulEvent)="onStripeSuccessfulEvent($event)"
    (stripElementLoadEvent)="onStripElementLoadEvent($event)"
    (storeBookingItemsEvent)="onStoreBookingItemsEvent()"
    (paypalSuccessfulEvent)="onPaypalSuccessfulEvent($event)"
    (resetPaypalEvent)="onResetPaypalEvent($event)"
    (paypalOrderStartedEvent)="isPaymentInProgress = true"
    (paypalCancelledEvent)="isPaymentInProgress = false"
    (cancelPaymentEvent)="onCancelPayment()"
    (saferpaySuccessfulEvent)="onSaferpaySuccessfulEvent($event)"
    [hostDrivesSubmit]="true"
    [adyenResumeSnapshot]="adyenResumeSnapshot"
    [reservationExpired]="isReservationExpired"
    (adyenPaymentStartedEvent)="onAdyenPaymentStarted()"
    (adyenSuccessfulEvent)="onAdyenPaid($event)"
    (resetAdyenEvent)="onAdyenReset()"
    (payAgainEvent)="showRefundNotice = false"
    (resetSaferpayEvent)="onResetSaferpayEvent($event)"
    (invoiceAddressChangeEvent)="onInvoiceAddressChangeEvent($event)"
    role="form"
    [attr.aria-label]="'Payment methods'"
  />
</ng-template>

<ng-template #cartOverviewTemplate let-mode="mode">
  <app-appointment-cart-overview
    [mode]="mode"
    (removeFromCartEvent)="removeFromCart($event, true, appointmentConstant.SUMMARY)"
    [(totalCartDuration)]="totalCartDuration"
    [(totalCartPrice)]="totalCartPrice"
    [(customFieldsAddonsPrice)]="customFieldsAddonsPrice"
    [(userState)]="userState"
    [appointmentServicesAvailable]="appointmentServicesAvailable"
    [cart]="cart"
    [coupon]="coupon"
    [finalCouponDiscount]="finalCouponDiscount"
    [lang]="lang"
    [partner]="partner"
    [courtesyForm]="courtesyForm"
    [widgetTemplates]="widgetTemplates"
    [appointmentState]="appointmentState"
    [conferenceState]="conferenceState"
    [stores]="stores"
    [globals]="globals"
    [customFields]="addonsCustomFields"
    [selectedJsonCustomFields]="selectedJsonCustomFields"
    [(customFieldValues)]="customFieldValues"
    [customFieldValuesLSNameKey]="CUSTOMFIELDS_LS_NAME"
    (updateCartEvent)="updateCart($event)"
    role="region"
    [attr.aria-label]="'Cart overview' + (mode === appointmentConstant.SUMMARY ? ' - Summary' : '')"
  />
</ng-template>
